import React, { useState, useEffect } from "react";
import carregando from "../../assets/loading.gif";
import api from "../../services/api";
import Header from "../../Header";
import SideMenu from "../../SideMenu";
import Footer from "../../Footer";

export default function Edit_Avaliacao({ history }) {
  const [avaliacao, setAvaliacao] = useState([]);
  const [treinamento, setTreinamento] = useState([]);
  const [loading, setLoading] = useState("");

  const url_string = window.location.href;
  const param = url_string.split("/");
  const usernome = localStorage.getItem("sgiusernome");
  const userid = localStorage.getItem("sgiuserid");
  const empresaid = localStorage.getItem("sgiempresaid");
  const isMaster = localStorage.getItem("sgimaster");
  const reqHeaders = { headers: { "x-tenantid": empresaid, isMaster } };

  async function loadAvaliacao() {
    const query = "/treinamentos/avaliacao/produto/" + param[4];
    const response = await api.get(query, reqHeaders);
    const data = await response.data;
    setAvaliacao(data);
  }

  async function loadProduto() {
    const query = "/treinamentos/produtocliente/" + param[4];
    const response = await api.get(query, reqHeaders);
    const data = await response.data;
    setTreinamento(data);
  }

  async function handleSubmit(event) {
    setLoading(true);
    event.preventDefault();

    let notaProva = 0;
    let notaFinal = 0;



    avaliacao.map((item) => {
      if(document.getElementById(item._id+"_"+item.respCorreta).checked){
        notaProva = notaProva + 1;
      }
    })

    notaFinal = ((notaProva / avaliacao.length) * 100) / 10 ;
    
    const dataobj = { 
      idproduto: param[4],
      idusuario: userid,
      nota: notaFinal
    }

    if(notaFinal > 6){
      alert("Parabéns você foi aprovado ! Seu certificado estará disponível na pagina principal.")
      dataobj.status = 1;
      dataobj.prova = 1;
  
      await api.post('/generateCertificadoPDF/' + param[4], {idusuario: userid, idempresa: empresaid})
      .then((res) => {
        if(res.data.error != undefined){
            alert(res.data.error);
            return;
        }else{
          dataobj.linkCertificado = res.data.pdflink
        }
        }).catch((error) => {
            alert(error);
            return;
        });
      
    } else {
      alert("Infelizmente você não atingiu a pontuação necessária, por favor revise o treinamento e tente novamente !")
      dataobj.status = 0;
      dataobj.prova = 0;
    }

    await api.put('/treinamentos/produtocliente/' + param[4], dataobj);
    setLoading(false);
    window.location = "/painel"


};

  useEffect(async () => {
    setLoading(true);
    await loadAvaliacao();
    await loadProduto();
    setLoading(false);
  }, []);


  return (
    <>
      <Header />
      <SideMenu />

      <div className="content-wrapper">
        <section className="content-header">
          <h1>
            {"Avaliação"}
            <small>&nbsp;({treinamento[0]?.titulo})</small>
          </h1>
        </section>

        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="box box-info">
                {loading && (
                  <div style={{ alignItems: "center", textAlign: "center" }}>
                    <img src={carregando} width="80"></img>
                  </div>
                )}

                <form className="form-horizontal" onSubmit={handleSubmit}>
                  <div className="box-body">
                    Usuario: {usernome}
                    <br></br>
                    Treinamento: {treinamento[0]?.titulo}
                    <div className="col-md-12 nopadding">
                      {avaliacao.map((item) => (
                        <div className="form-group">
                          <label className="col-sm-12">
                            {item.pergunta}
                          </label>
                          {item.respostas.map((itemResp, index) => (
                            <div className="col-sm-12">
                              <input type="radio" name={item._id} id={item._id + "_" + index} value={index} required /><span> {itemResp}</span>
                          </div>
                          ))}
                          
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="box-footer">
                    <button
                      type="button"
                      className="btn btn-default"
                      style={{ marginRight: 8 }}
                      onClick={() => window.location = "/painel"}
                    >
                      Voltar
                    </button>
                    <button type="submit" className="btn btn-success">
                      Enviar Respostas
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
}
